export default {"src":"/_next/static/media/ActiveProjects.f7255e62.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};